import { Command, Data, Filters } from '../commands';
import { SortFactory } from '../factories';
import { Handler } from './ChainOfResponsibility';

export class SortHandler implements Handler {
    private nextHandler: Handler | null = null;
    private sortType: string;
    private keys: Filters;
    private command: Command;

    constructor({ sortType, keys }: { sortType: string; keys: Filters }) {
        this.sortType = sortType;
        this.keys = keys;
        this.command = SortFactory.createCommand(this.sortType);
    }

    setNext(handler: Handler): void {
        this.nextHandler = handler;
    }

    getNext(): Handler | null {
        if (this.nextHandler) {
            return this.nextHandler;
        }
        return null;
    }

    getCommand(): Command {
        return this.command;
    }

    handleRequest(data: Data): Data {
        const sortedData = this.command.execute(data, this.keys);
        if (this.nextHandler) {
            return this.nextHandler.handleRequest(sortedData);
        }
        return Array.from(new Set(sortedData as []));
    }
}
